/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// Uses @compiled/react because keyframes() is not available from @atlaskit/css.
import { cssMap, keyframes } from '@compiled/react';

import { jsx } from '@atlaskit/css';

const flickerAnimation = keyframes({
	'0%': { opacity: 1 },
	'50%': { opacity: 0.5 },
	'100%': { opacity: 1 },
});

const loadingStateAnimationWrapperStyles = cssMap({
	wrapper: {
		position: 'relative',
		animationName: flickerAnimation,
		animationDuration: '2s',
		animationIterationCount: 'infinite',
	},
});

export const LoadingStateAnimationWrapper = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={loadingStateAnimationWrapperStyles.wrapper} {...props}>
		{children}
	</div>
);
